<template>
  <div
    id="dashboard"
    class="row w-100 pl-5 justify-content-start bg-blue-light"
    :style="{
      //backgroundImage: `url(${require('@/assets/img/page_bg.png')})`,
      paddingRight: '0px',
      margin: '0px',
      padding: '0px !important',
    }"
  >
    <div class="container-fluid">
      <!-- 查詢 -->
      <div class="card">
        <div class="card-body">
          <form class="row g-3">
            <div class="col-md-3">
              <label for="inputEmail4" class="form-label">活動開始</label>
              <datetime
                input-class="form-control form-control-sm"
                type="date"
                format="yyyy-MM-dd"
                :phrases="{ ok: '確認', cancel: '取消' }"
                :minute-step="1"
              
                :auto="true"
                v-model="startTime"
              >
              </datetime>
            </div>
            <div class="col-md-3">
              <label for="inputPassword4" class="form-label">活動結束</label>
              <datetime
                input-class="form-control form-control-sm"
                type="date"
                format="yyyy-MM-dd"
                :phrases="{ ok: '確認', cancel: '取消' }"
                :minute-step="1"
              
                :auto="true"
                v-model="endTime"
              >
              </datetime>
            </div>
            <div class="col-md-3">
              <label for="inputAddress" class="form-label">活動名稱</label>
              <input
                type="text"
                class="form-control form-control-sm"
                id="exampleFormControlInput1"
                placeholder="請輸入關鍵字"
                v-model="activityName"
              />
            </div>
            <div class="col-md-2 d-flex align-items-end">
              <a
                href="#"
                class="btn btn-success bg-cyan btn-sm rounded-pill px-3"
                @click="searchData"
              >
                <i class="fas fa-search"></i> 查詢</a
              >
            </div>
          </form>
        </div>
      </div>

      <!-- 新增 -->
      <div class="d-flex justify-content-between">
        <div class="pt-2">
          <h1>活動列表</h1>
        </div>
        <div class="pt-2 mt-3">
          <a
            href="#"
            class="btn btn-primary bg-indigo btn-sm rounded-pill px-3 mb-2"
            data-bs-toggle="modal"
            data-bs-target="#activityModal"
            @click="addActivity"
            ><i class="fas fa-plus"></i> 活動新增</a
          >
        </div>
      </div>

      <!-- 列表 -->
      <div class="row row-cols-1 row-cols-md-4 row-cols-lg-4 row-cols-flex g-4">
        <div class="col" v-for="(activity, i) in activityList" :key="i">
          <div class="card card-clean h-100">
            <div :class="'card-header text-white p-0 '+ getOverlayCss(activity)">
              <p class="overlay-content">{{getOverlayText(activity)}}</p>
              <div v-if ="activity.photoType">
                <img class="card-img-top card-img-height active-photo"
                  :src="activity.photoType? 'data:' +activity.photoType +';base64,'+activity.photoBase64
                      : 'data:image/png;base64,' + activity.photoBase64"
                  alt="bg"/>
              </div>

              <div v-if ="!activity.photoType"
                class="card-img-top card-img-height non-photo"
                alt="bg">

            </div>
            </div>
            <div class="card-body p-2">
              <h6 class="text-dark fw-bold event-title">
                {{ activity.activityName }}
              </h6>
              <p class="small text-body">{{ getTime(activity) }}</p>
              <div class="d-flex justify-content-end align-items-center">
                <a
                  v-if="activity.status !== ACTIVITY_STATUS.END"
                  href="#"
                  class="btn btn-primary bg-indigo btn-sm mx-1 px-1 py-0"
                  data-bs-toggle="modal"
                  data-bs-target="#activityModal"
                  @click="editActivity(activity)"
                  >編輯</a
                >
                <!-- <router-link
                  v-if="activity.status === ACTIVITY_STATUS.DURING"
                  :to="{
                    name: '/activity/activityDetail/:id',
                    params: { id: activity.id },
                  }"
                  class="on-default edit-row"
                > -->
                <div v-if="activity.status === ACTIVITY_STATUS.DURING">
                  <a
                    href="https://moonseafestival.iisi-isurveillance.com/"
                    class="btn btn-success bg-cyan btn-sm mx-1 px-1 py-0"
                    target="blank"
                  >
                    進入
                  </a>

                </div>
                <!-- <router-link
                  v-if="activity.status === ACTIVITY_STATUS.DURING"
                  :to="{
                    name: '/activity/activityDetail',
                  }"
                  class="on-default edit-row"
                >
                  <a class="btn btn-success bg-cyan btn-sm mx-1 px-1 py-0"
                    >進入</a
                  >
                </router-link> -->
                <router-link
                  v-if="activity.status === ACTIVITY_STATUS.END"
                  :to="{
                    name: '',
                    params: { id: activity.id },
                  }"
                  class="on-default edit-row"
                >
                <router-link to="/searchActivity">
                  <a class="btn btn-success bg-cyan btn-sm mx-1 px-1 py-0"
                    >查詢</a
                  ></router-link>
                  
                </router-link>
                <a
                  href="#"
                  class="btn btn-danger bg-red btn-sm mx-1 px-1 py-0"
                  @click="(e) => deleteActivity(activity, e)"
                  >刪除</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增活動Modal -->
    <div class="modal fade" id="activityModal" tabindex="-1"  ref="dialogModal" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog  modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header p-2 bg-indigo">
            <h6 class="modal-title fw-bold text-white pb-0" id="exampleModalLabel">
              {{
                pageMode === Const.DIALOG_MODE.EDIT_DEVICE ? "編輯" : "新增"
              }}活動</h6>
            <button type="button" class="btn-close text-white" data-bs-dismiss="modal" aria-label="Close" @click="dismissDL"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row mb-1">
                <label for="inputEmail3" class="col-sm-3 col-form-label">活動編號</label>
                <div class="col-sm-9">
                  <input type="text" class="form-control form-control-sm" id="inputEmail3" v-model="edittingActivityData.id"
                    Disabled>
                </div>
              </div>
              <div class="row mb-1">
                <label for="inputEmail3" class="col-sm-3 col-form-label">活動名稱<sup class="text-red">*</sup></label>
                <div class="col-sm-9">
                  <input type="text" class="form-control form-control-sm" id="inputEmail3" placeholder="請輸入活動名稱" v-model="edittingActivityData.activityName">
                </div>
              </div>
              <div class="row mb-1">
                <label for="inputEmail3" class="col-sm-3 col-form-label">活動照片</label>
                <div class="col-sm-9">
                  <div class="input-group">
                    <input type="file" class="form-control form-control-sm" id="inputGroupFile04" style="line-height: 1.5"
                      aria-describedby="inputGroupFileAddon04" aria-label="Upload"  @change="handleFileUpload">
                    <!-- <button class="btn btn-sm btn-dark" type="button" id="inputGroupFileAddon04">上傳</button> -->
                  </div>
                  <div id="emailHelp" class="form-text">請上傳寬度800px，高度420px，jpg或png檔案格式。</div>
                </div>
              </div>
              <div class="row mb-1">
                <label for="inputEmail3" class="col-sm-3 col-form-label">活動時間<sup class="text-red">*</sup></label>
                <div class="col-sm-9">
                  <datetime
                      input-class="form-control form-control-sm"
                      type="datetime"
                      format="yyyy-MM-dd HH:mm"
                      :phrases="{ ok: '確認', cancel: '取消' }"
                
                      :auto="true"
                      v-model="edittingActivityData.startDate"
                    ></datetime> 
                    <datetime
                      input-class="form-control form-control-sm"
                      type="datetime"
                      format="yyyy-MM-dd HH:mm"
                      :phrases="{ ok: '確認', cancel: '取消' }"
      
                      :auto="true"
                      v-model="edittingActivityData.endDate"
                    >
                    </datetime>
                </div>
              </div>
              <div class="row mb-1">
                <label for="inputEmail3" class="col-sm-3 col-form-label">容留人數<sup class="text-red">*</sup></label>
                <div class="col-sm-9">
                  <input
                      type="number"
                      class="form-control form-control-sm"
                      v-model.number="edittingActivityData.maximumOccupancy"
                    />
                </div>
              </div>
              <div class="row mb-1">
                <label for="inputPassword3" class="col-sm-3 col-form-label">剩餘車位<sup class="text-red">*</sup></label>
                <div class="col-sm-9">
                  <input
                      type="number"
                      class="form-control form-control-sm"
                      v-model.number="edittingActivityData.remainingParkingSpot"
                    />
                </div>
              </div>
              <div class="row mb-1">
                <label for="inputPassword3" class="col-sm-3 col-form-label">警戒參數<sup class="text-red">*</sup></label>
                <div class="col-sm-4"> <b>人流</b>
                  <div class="input-group mb-1">
                    <input type="number" class="form-control form-control-sm" placeholder="請輸入上限" aria-label="請輸入上限" aria-describedby="button-addon2"
                      v-model.number="
                        edittingActivityData.orangeThresholdForPeople
                      ">
                    <button class="btn btn-warning btn-sm fw-bold" type="button" id="button-addon2">橘燈</button>
                  </div>
                  <div class="input-group mb-1">
                    <input type="number" class="form-control  form-control-sm" placeholder="請輸入上限" aria-label="請輸入上限"  aria-describedby="button-addon2"
                      v-model.number="
                        edittingActivityData.redThresholdForPeople
                      ">
                    <button class="btn btn-danger btn-sm fw-bold" type="button" id="button-addon2">紅燈</button>
                  </div>
                </div>
                <div class="col-sm-4"> <b>車流</b>
                  <div class="input-group mb-1">
                    <input type="number" class="form-control form-control-sm" placeholder="請輸入上限" aria-label="請輸入上限" aria-describedby="button-addon2"
                      v-model.number="
                        edittingActivityData.orangeThresholdForvehicle
                      ">
                    <button class="btn btn-warning btn-sm fw-bold" type="button" id="button-addon2">橘燈</button>
                  </div>
                  <div class="input-group mb-1">
                    <input type="number" class="form-control  form-control-sm" placeholder="請輸入上限" aria-label="請輸入上限"  aria-describedby="button-addon2"
                      v-model.number="
                        edittingActivityData.redThresholdForvehicle
                      ">
                    <button class="btn btn-danger btn-sm fw-bold" type="button" id="button-addon2">紅燈</button>
                  </div>
                </div>
              </div>
              <div class="row mb-1">
                <label for="inputEmail3" class="col-sm-3 col-form-label">備註</label>
                <div class="col-sm-9">
                  <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="edittingActivityData.remark"
                    />
                </div>
              </div>
              <div class="row mb-1">
                <label for="inputEmail3" class="col-sm-3 col-form-label">建立者</label>
                <div class="col-sm-9">
                  <input type="text" class="form-control form-control-sm" id="inputEmail3" :value="getActivityCreator()" Disabled>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer p-2">
            <button type="button" class="btn btn-secondary btn-sm rounded-pill px-3" data-bs-dismiss="modal" @click="dismissDL">取消</button>
            <button type="button" class="btn btn-primary btn-sm rounded-pill px-3" data-bs-dismiss="modal" @click="executeDL">
              {{ pageMode === Const.DIALOG_MODE.EDIT_DEVICE ? "編輯" : "新增" }}
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import Utils from "../../utils/utils";
import CONST from "../../utils/const";
import imageBase64 from "../../utils/imageBase64";
import { users, my, roles } from "@/resource";
import { list } from "@/mixins";

export default {
  mixins: [list],
  data() {
    return {
      ACTIVITY_STATUS: {
        WILL: CONST.ACTIVITY_STATUS.WILL,
        DURING: CONST.ACTIVITY_STATUS.DURING,
        END: CONST.ACTIVITY_STATUS.END
      },
      OVERLAY_CSS: {
        none: "",
        overlay: "overlay",
        overlay_primary: "overlay-primary"
      },
      resource: users,
      Const: CONST,
      accountName: "",
      startTime: moment(moment().clone().startOf("month").format("YYYY-MM-DD hh:mm")).format(), //vue-datetime-24period
      endTime: moment(moment().clone().endOf("month").format("YYYY-MM-DD hh:mm")).format(),
      activityName: "",
      pageMode: CONST.DIALOG_MODE.VIEW,
      edittingActivityData: {},
      selectedImage: null,
    };
  },
  computed: {
    maxSelectTime() {
      return moment().startOf("m").toISOString();
    },
    ...mapState("activity", { activityList: "activities" }),
  },
  watch: {
    activityList() {

    },
  },
  methods: {
    openModal() {
      $(this.$refs.dialogModal).modal("show");
    },
    closeModal() {
      $(this.$refs.dialogModal).modal("hide");
    },
    async searchData() {
      if (moment(this.endTime).diff(moment(this.startTime)) < 0) {
        alert('結束時間不可以小於開始時間')
        return
      }

      const condition = {
        startTime: this.startTime,
        endTime: this.endTime,
        activityName: this.activityName,
      };
      await this.$store.dispatch("activity/getActivities", condition);
    },

    handleFileUpload(event) {
      const file = event.target.files[0];
      
      this.selectedImage = file; // 保存所選的圖片文件
      
    },
    addActivity() {
      this.initedittingActivityData();
      this.pageMode = CONST.DIALOG_MODE.ADD_DEVICE;
      this.openModal();
    },

    editActivity(activity) {
      this.edittingActivityData = JSON.parse(JSON.stringify(activity));
      this.edittingActivityData.startDate = moment(moment(this.edittingActivityData.startDate).clone().format("YYYY-MM-DD HH:mm")).format()
      this.pageMode = CONST.DIALOG_MODE.EDIT_DEVICE;
      this.openModal();
    },

    async deleteActivity(activity, e) {
      e.preventDefault(); //防止confirm後 scroll to top 
      const isCheck = confirm('確認刪除此活動 ?')
      if(!isCheck) {
        return 
      }

      await this.$store.dispatch("activity/deleteActivity",activity);
    },

    dismissDL() {
      this.cleanFileName();
      this.closeModal();
      this.pageMode === CONST.DIALOG_MODE.VIEW;
    },

    executeDL() {
      console.log('executeDL', this.edittingActivityData.startDate)
      console.log('executeDL', this.edittingActivityData.endDate)
      if (
        Utils.isEmptyObject(this.edittingActivityData.startDate) ||
        Utils.isEmptyObject(this.edittingActivityData.endDate)
      ) {
        alert("請選擇起訖時間");
        return;
      }

      if (
        moment(this.edittingActivityData.endDate).diff(
          moment(this.edittingActivityData.startDate)
        ) < 0
      ) {
        alert("結束時間不可以小於開始時間");
        return;
      }

      switch (this.pageMode) {
        case CONST.DIALOG_MODE.EDIT_DEVICE:
          this.updateActivity();
          this.cleanFileName();
          break;

        case CONST.DIALOG_MODE.ADD_DEVICE:
          this.createActivity();
          this.cleanFileName();
          break;
      }

      // this.$store.dispatch('videoCamera/getCCTV') // 確保videoCamera也是新的資料(給map使用)
    },
    async getImageBase64() {
      if (!Utils.isEmptyObject(this.selectedImage)) {
        await imageBase64
          .getImageBase64(this.selectedImage)
          .then(({ base64String, mimeType }) => {
            this.edittingActivityData.photoType = mimeType;
            this.edittingActivityData.photoBase64 = base64String;
          })
          .catch((error) => {
            console.error(error);
            // 在這裡處理錯誤
          });
      }
    },

    async updateActivity() {
      await this.getImageBase64();

      this.selectedImage = undefined;
      const result = await this.$store.dispatch(
        "activity/putActivity",
        this.edittingActivityData
      );
      if (result.success) {
        this.dismissDL();
      } else {
        alert("編輯失敗");
      }
    },

    async createActivity() {
      await this.getImageBase64();

      this.selectedImage = undefined;
      this.edittingActivityData.creator = this.getUserGuid();

      const result = await this.$store.dispatch(
        "activity/postActivity",
        this.edittingActivityData
      );
      if (result.success) {
        this.dismissDL();
      } else {
        alert("新增失敗");
      }
    },

    cleanFileName(){
      const fileInput = document.getElementById('inputGroupFile04');
        if (fileInput) {
          // 清空文件輸入框的值
          fileInput.value = "";
        }
    },

    getOverlayText(activity) {
      let text= ""
      switch(activity.status) {
        case this.ACTIVITY_STATUS.WILL:
          text = '尚未開始'
          break
        case this.ACTIVITY_STATUS.END:
          text = '已結束'
          break
        case this.ACTIVITY_STATUS.WILL:
          text = ''
          break
      }

      return text
    },

    getOverlayCss(activity) {
      let css= ""
      switch(activity.status) {
        case this.ACTIVITY_STATUS.WILL:
          css = this.OVERLAY_CSS.overlay +" " + this.OVERLAY_CSS.overlay_primary
          break
        case this.ACTIVITY_STATUS.END:
          css = this.OVERLAY_CSS.overlay
          break
        case this.ACTIVITY_STATUS.WILL:
          break
      }

      return css
    },

    getTime: function (event) {
      let startDate = "-";
      let endDate = "-";
      if (Utils.isEmptyObject(event.startDate)) {
        startDate = "-";
      }

      if (Utils.isEmptyObject(event.endDate)) {
        endDate = "-";
      }

      startDate = moment(event.startDate).format("YYYY/MM/DD HH:mm");
      endDate = moment(event.endDate).format("YYYY/MM/DD HH:mm");

      return `${startDate} ~ ${endDate}`;
    },

    getUserGuid() {
      const myAccount = this.rows.filter(
        (user) => user.name === this.accountName
      )[0];
      return Utils.isEmptyObject(myAccount) ? "" : myAccount.id;
    },

    getActivityCreator() {
      if(Utils.isEmptyObject(this.edittingActivityData))
        return '-'

      const creators = this.rows.filter(
        (user) => user.id === this.edittingActivityData.creator
      );

      return Utils.isEmptyObject(creators)? this.edittingActivityData.creator : creators[0].name
    },

    initedittingActivityData() {
      
      this.edittingActivityData = {
        id: "",
        activityName: "",
        photoType: "",
        photoBase64: "",
        startDate: moment(moment().clone().startOf("month").format("YYYY-MM-DD hh:mm")).format(),
        endDate: moment().startOf("hour").format(), //
        maximumOccupancy: 0,
        remainingParkingSpot: 0,
        orangeThresholdForPeople: 0,
        redThresholdForPeople: 0,
        orangeThresholdForvehicle: 0,
        redThresholdForvehicle: 0,
        remark: "",
        creator: "",
        status: "",
      };

      console.log('initedittingActivityData', this.edittingActivityData);
    },
  },
  async mounted() {
    this.initedittingActivityData();
    await this.$store.dispatch("activity/getAllActivity");
    my.info().then((a) => {
      this.accountName = a.body.name;
    });

    // console.log(this.rows)
    // console.log(await users.roles({ id: this.rows[0].id }))

  },
};
</script>
<style  scoped>
.non-photo{
  background-color: darkslategray;
  opacity: .4;
}

.active-photo{
  height: 150px;
  object-fit: cover;

}

#activityModal{
  padding-right:0px !important ;
}


</style>